import { FETCH_STATUS_ENUM } from '../../../common/enums/enums';
import { updateStatus } from '../features/productmanagement/slices/tabProductsSlice';

export const handleKoganResponse = (resp,productId,message,dispatch) => {
    const result = resp.data.results[0];
    if(result && result.status === FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.status){
      const status = FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.buildStatus(result.pending_url);
      dispatch(updateStatus({product_sku: productId, status}));
      message.warning('Response Pending - Please do not close the tab. Click Check Status to confirm if saving is complete');     
    } else if (result && result.status === FETCH_STATUS_ENUM.KOGAN_COMPLETE_WITH_ERRORS.status) {
        dispatch(updateStatus({product_sku: productId, status:FETCH_STATUS_ENUM.KOGAN_COMPLETE_WITH_ERRORS}));
        message.error(`Error: ${result.error} \r ${JSON.stringify(result.body)}`,10);

    }
    else if(result && result.status === FETCH_STATUS_ENUM.KOGAN_COMPLETE.status){
        dispatch(updateStatus({product_sku: productId, status:FETCH_STATUS_ENUM.KOGAN_COMPLETE}));
          
        if(result.body?.warnings?.length > 0){
            message.warning(`Saved with warnings: ${JSON.stringify(result.body.warnings)}`,10);
        }else{
            message.success(
                'Success! To see results in grid, please use the Refresh Grid button'
              );
        }
    } else if (result && result.status === FETCH_STATUS_ENUM.KOGAN_FAILED.status) {
        dispatch(updateStatus({product_sku: productId, status:FETCH_STATUS_ENUM.KOGAN_FAILED}));
      message.error(`Error: ${resp.data.error}`,10);
    } else if(resp.data.status !== true){
        dispatch(updateStatus({product_sku: productId, status:FETCH_STATUS_ENUM.GENERIC_ERROR}));
        message.error(resp.data.message,10);
    } else{
        message.warning('Unknown response',10);
    }
}

export const extractTaskIdFromPendingUrl = (url) => {
    
    return url.match(/\/([^/]+)\/$/)[1];
}